import React from 'react';

import {Typography} from '@mui/material';
import {Alert} from '@netx/core-components/Alert';
import Button from '@netx/core-components/Button';
import Dialog, {DialogProps} from '@netx/core-components/Dialog';
import {CUSTOM_ACTION_MESSAGE, CUSTOM_ACTION_LABEL} from '../../locales';
import type {UserCustomAction} from '../../types';

export type CustomActionBlockingDialogProps = Pick<
	DialogProps,
	'onClose' | 'open'
> & {
	blocking?: boolean;
	errorMessage?: string;
	successMessage?: string;
	userCustomAction: UserCustomAction;
	DialogProps?: Partial<DialogProps>;
};

export const CustomActionBlockingDialogPrimitive = ({
	blocking,
	errorMessage,
	successMessage,
	userCustomAction,
	onClose,
	DialogProps,
	...props
}: CustomActionBlockingDialogProps) => {
	return (
		<Dialog
			dialogActions={
				!blocking ? (
					<Button variant="text" onClick={() => onClose?.({}, 'escapeKeyDown')}>
						{CUSTOM_ACTION_LABEL.CLOSE}
					</Button>
				) : undefined
			}
			title={userCustomAction.name}
			isWorking={blocking}
			preventBackdropClose
			fullWidth
			maxWidth="sm"
			onClose={blocking ? undefined : onClose}
			{...DialogProps}
			{...props}
		>
			{errorMessage || successMessage ? (
				<Alert severity={errorMessage ? 'error' : 'success'}>
					{errorMessage || successMessage}
				</Alert>
			) : (
				<Typography variant="body1">
					{CUSTOM_ACTION_MESSAGE.PERFORMING_ACTION}
				</Typography>
			)}
		</Dialog>
	);
};

export const CustomActionBlockingDialog = CustomActionBlockingDialogPrimitive;

export default CustomActionBlockingDialog;
